var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import { css } from 'styled-components';
export var TIMEOUT_IN = 500;
export var TIMEOUT_OUT = 300;
export var EASE = [0.5, 0, 0, 1];
export var flyoutTransitionMixin = function () {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i] = arguments[_i];
    }
    var propertiesString = properties.join(', ');
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    transition-property: ", ";\n    transition-duration: ", "ms;\n    transition-timing-function: cubic-bezier(", ");\n  "], ["\n    transition-property: ", ";\n    transition-duration: ", "ms;\n    transition-timing-function: cubic-bezier(", ");\n  "])), propertiesString, function (_a) {
        var theme = _a.theme;
        return theme.isFlyout ? TIMEOUT_IN : TIMEOUT_OUT;
    }, EASE.join(', '));
};
export var flyoutTransition = {
    type: 'tween',
    ease: EASE,
    precision: 0.01
};
export var useFlyoutVariants = function (_a) {
    var initial = _a.initial, animate = _a.animate, exit = _a.exit;
    return useMemo(function () { return ({
        initial: 'initial',
        animate: 'animate',
        exit: 'exit',
        variants: {
            initial: __assign(__assign({}, initial), { transition: __assign(__assign({}, flyoutTransition), { duration: TIMEOUT_IN / 1000 }) }),
            animate: __assign(__assign({}, animate), { transition: __assign(__assign({}, flyoutTransition), { duration: TIMEOUT_IN / 1000 }) }),
            exit: __assign(__assign({}, exit), { transition: __assign(__assign({}, flyoutTransition), { duration: TIMEOUT_OUT / 1000 }) })
        }
    }); }, [animate, exit, initial]);
};
var templateObject_1;
